import joiBlokes from '../../assets/project300/joi-blokes.png'
import opt from '../../assets/project300/opt.png'
import trx from '../../assets/project300/trx.png'
import pqlife from '../../assets/project300/pqlife.png'
import flex from '../../assets/project300/flex.png'
import cook from '../../assets/project300/cook.png'
import f45 from '../../assets/project300/f45.png'
import qualia from '../../assets/project300/qualia.png'
import hiqor from '../../assets/project300/hiqor.png'
export default {
  state: {
    partnerItems: [
      {
        id: 1,
        name: `Optimize Your Baseline`,
        description: `Joi + Blokes provides science-backed biomarker testing to track your health. They’ll run blood tests at the start and end of Project 300 to measure transformation.`,
        image: joiBlokes,
        url: `https://joiandblokes.com`
      },
      {
        id: 2,
        name: `Track Your Health`,
        description: `Opt Health helps optimize your hormones and metabolism. They’ll provide blood tests at the start and end of Project 300 to measure progress of military participants.`,
        image: opt,
        url: `https://getopt.com`
      },
      {
        id: 3,
        name: `Suspension weight training`,
        description: `Members receive 20% off the online store and merch bunker. Free shipping and returns saves you even more. `,
        image: trx,
        url: `https://www.trxtraining.com`
      },
      {
        id: 4,
        name: `Unlock insights`,
        description: `PQ Life provides a free assessment and quick report, with an optional $10 Top 5 report. Participants also get free access to PQ Life’s Discord community, PassionAI®.`,
        image: pqlife,
        url: `https://www.mypqlife.com`
      },
      {
        id: 5,
        name: `Simplify Health Spending`,
        description: `Flex helps manage your HSA and FSA accounts, making it easier to pay for health and wellness expenses throughout Project 300.`,
        image: flex,
        url: `https://www.withflex.com/`
      },
      {
        id: 6,
        name: `Fuel Your Performance`,
        description: `CookUnity provides 4 meals per week for the first 4 weeks of Project 300. After that, participants can continue with a 10% discount on all meals.`,
        image: cook,
        url: `https://www.cookunity.com`
      },
      {
        id: 7,
        name: `Unlock your potential`,
        description: `Each Project 300 participant gets 6 months of free F45 gym access to power through workouts, build strength, and stay consistent.`,
        image: f45,
        url: `https://f45training.com`
      },
      {
        id: 8,
        name: `Enhance Your Performance`,
        description: `All Project 300 participants receive 3 Qualia Performance Bundles, including Joint, NAD, Magnesium, Mitochondria+, Mind, and Night supplements to support energy, recovery, and focus.`,
        image: qualia,
        url: `https://www.qualialife.com`
      },
      {
        id: 9,
        name: `Track Your Health`,
        description: `HIQOR provides unlimited facial scans (minimum of 2) during Project 300 to monitor skin health and track visible progress over time.`,
        image: hiqor,
        url: `https://www.hiqor.com`
      }
    ],
    faqItems: [
      {
        id: 1,
        question: `When does the study start?`,
        answer: `We officially kick off January 1st. No warm-up laps, no excuses. You’ve got two months to get ready. Take advantage of every partner offer—especially the blood marker draw from Joi + Blokes so we can get your baseline health data locked in. The more prepared you are, the stronger you start.`
      },
      {
        id: 2,
        question: `What should I do between now and January 1st?`,
        answer: `Start acting like the person you want to become—now. Tell your friends and family you’re doing this. Accountability matters. Follow @300hardway and show us how you’re prepping. Hydrate. Clean up your nutrition. Get the alcohol out of the house. Delete distractions off your phone. And make sure you hit the F45 link to get your gym membership squared away. We start strong, not sloppy. And most importantly - download the Spartan EDGE app. This is where you will receive communication from your coach and get your weekly workouts!`
      },
      {
        id: 3,
        question: `What if I get injured or need to drop out?`,
        answer: `Injuries happen. Quitting doesn’t have to. If you get hurt—see a doctor. Then talk to your coach. We’ll modify your training so you can keep improving without making things worse. If you truly need to step out, we get it—but don’t disappear. You can still follow the plan. Eat clean. Cut the alcohol. Move however you can. Stay in the fight.`
      },
      {
        id: 4,
        question: `What if there’s no F45 gym near me?`,
        answer: `No gym? No problem. Excuses don’t build results. You can download the F45 Training App for at-home workouts, and with your TRX Bandit System, you’ve got everything you need to crush it anywhere—garage, backyard, hotel room, doesn’t matter. Just move.`
      },
      {
        id: 5,
        question: `How will I be connected with my coach?`,
        answer: `In a few weeks, we’ll announce your pod—your team for the next 200 days. You’ll get a direct intro to your coach, who will keep you accountable, help modify workouts if needed, and push you past your limits when you start to doubt yourself.`
      },
      {
        id: 6,
        question: `Do I need to buy anything else?`,
        answer: `Nope. Everything you need is covered through our partners—Joi + Blokes, TRX, F45, CookUnity, Qualia, and Flex. The only thing we can’t give you is effort. That’s on you.`
      },
      {
        id: 7,
        question: `How much time will this take each week?`,
        answer: `Expect about an hour a day for training, plus the time you’ll spend on recovery, mindset, and fueling your body right. The bigger question isn’t “how long will it take?”—it’s “how badly do you want it?”`
      },
      {
        id: 8,
        question: `Will there be nutrition guidance?`,
        answer: `Yes. CookUnity and our team will provide direction based on your goals. Start by cleaning up your plate—ditch processed junk, hydrate, and eat like you respect yourself. More details are coming soon on nutrition tracking and check-ins.`
      },
      {
        id: 9,
        question: `How do I track progress?`,
        answer: `You’ll record workouts, mood, and progress directly in your Project 300 account. We’re not guessing here—we’re measuring real change through consistent tracking and feedback.`
      },
      {
        id: 10,
        question: `Can I share my journey on social media?`,
        answer: `Absolutely—and you should. Tag @300hardway, @spartan, and our partners. Use the hashtag #Project300. We’re building a movement, and your story could inspire the next person to change their life.`
      },
      {
        id: 11,
        question: `What happens when the 200 days are over?`,
        answer: `That’s when you find out who you really are. By Day 200, you’ll have earned something most people never will—proof that discipline and consistency can rebuild a life. We’ll celebrate big, but the real reward is the person you become in the process.`
      },
      {
        id: 12,
        question: `What if I fall behind?`,
        answer: `Then you get back up. This isn’t about being perfect—it’s about persistence. Miss a workout? Fine. Don’t miss two. Fall off your meal plan? Reset at the next meal. Progress beats perfection every time.`
      },
      {
        id: 13,
        question: `What’s expected of me as part of the Active Roster?`,
        answer: `Show up. Every day. Follow the plan. Engage with your pod. Support your teammates. Represent the project with pride and humility. You’re part of the 200 for a reason—earn it.`
      }
    ],
  },
  mutations: {
    toggleOnboardingItem(state, id, checked) {
      const item = state.onboardingItems.find(item => item.id === id);
      if (item) {
        item.checked = checked;
      }
    },
    updateMetric(state, payload) {
      console.log(payload)
      const metric = state.metricItems.find(el => el.id === payload.id)
      metric.progress.push({date: payload.date, value: payload.value})
    }
  },
  actions: {
    toggleOnboardingItem({ commit }, payload) {
      commit('toggleOnboardingItem', payload);
    }
  },
  getters: {
    onboardingItems: state => state.onboardingItems,
    partnerItems: state => state.partnerItems,
    faqItems: state => state.faqItems,
  }
};

